import { Header3 } from '@ardoq/typography';
import { TextOverflow } from '@ardoq/popovers';
import { FlexBox } from '@ardoq/layout';
import { ComponentTypeTagWithIcon } from './ComponentTypeTagWithIcon';
import { APIComponentAttributes } from '@ardoq/api-types';
import { EnhancedScopeData } from '@ardoq/data-model';

type NameAndIconProps = {
  component: APIComponentAttributes;
  scopeData: EnhancedScopeData;
};

const NameAndIcon = ({ component, scopeData }: NameAndIconProps) => {
  return (
    <FlexBox gap="small" align="center">
      <TextOverflow>
        <Header3>{component.name}</Header3>
      </TextOverflow>
      <ComponentTypeTagWithIcon component={component} scopeData={scopeData} />
    </FlexBox>
  );
};

export { NameAndIcon };
